import { useState } from 'react'

// local imports
import AuthUtil from 'utils/AuthUtil'
import { ISaveMeetingReservation } from 'types/MeetingRoomType'
import MeetingRoomService from 'service/MeetingRoomService'

export default function useSaveMeetingRoomReservation(resInfos: ISaveMeetingReservation[], closeAfterSave: () => void) {
  const [loading, setLoading] = useState(false)
  const employeeId = AuthUtil.getEmployeeSummary()?.id
  const bodyTemplate = resInfos?.map((ri) => ({ ...ri, employeeId: employeeId }))

  const saveMeetingReservation = () => {
    setLoading(true)
    const reqBody = { reservationList: bodyTemplate }
    MeetingRoomService.saveMeetingRoomReservation(reqBody)
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveMeetingReservation, loading }
}
